import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "./dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "airplay",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [],
  },

  {
    path: "./population-health/population",
    title: "Population & Health",
    moduleName: "population-health",
    iconType: "feather",
    icon: "users",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [],
  },

  {
    path: "/onboarding/farmers/container",
    title: "Farmers",
    moduleName: "onboarding",
    iconType: "feather",
    icon: "users",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [
    {
      path: "/onboarding/farmers/container",
      title: "All Farmers",
      moduleName: "farmers",
      iconType: "feather",
      icon: "list",
      class: "ml-menu",
      groupTitle: false,
      badge: "",
      badgeClass: "",
      role: ["ADMIN"],
      submenu: [],
    },
    {
      path: "/onboarding/farmers/search",
      title: "Farmer Lookup",
      moduleName: "farmers",
      iconType: "feather",
      icon: "search",
      class: "ml-menu",
      groupTitle: false,
      badge: "",
      badgeClass: "",
      role: ["ADMIN"],
      submenu: [],
    },
    {
      path: "/onboarding/farmers/muzzle-downloads",
      title: "Muzzle Downloads",
      moduleName: "farmers",
      iconType: "feather",
      icon: "download",
      class: "ml-menu",
      groupTitle: false,
      badge: "",
      badgeClass: "",
      role: ["ADMIN"],
      submenu: [],
    },{
      path: "/onboarding/farmers/validate",
      title: "Validate National ID",
      moduleName: "farmers",
      iconType: "feather",
      icon: "shield",
      class: "ml-menu",
      groupTitle: false,
      badge: "",
      badgeClass: "",
      role: ["ADMIN"],
      submenu: [],
    },
  ],
  },

  {
    path: "/onboarding/agro-veterinarians",
    title: "Agro-Veterinarians",
    moduleName: "onboarding",
    iconType: "feather",
    icon: "activity",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [],
  },

  {
    path: "./user-management/users",
    title: "User Management",
    moduleName: "user-management",
    iconType: "feather",
    icon: "user",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [
      // {
      //   path: "./user-management/roles",
      //   title: "Roles",
      //   moduleName: "user-management",
      //   iconType: "feather",
      //   icon: "shield",
      //   class: "ml-menu",
      //   groupTitle: false,
      //   badge: "",
      //   badgeClass: "",
      //   role: ["ADMIN"],
      //   submenu: [],
      // },
    ],
  },

  {
    path: "./vetenary-management/vetenary",
    title: "Veterinary Management",
    moduleName: "vetenary-management",
    iconType: "feather",
    icon: "life-buoy",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [],
  },

  // ── Reports ───────────────────────────────────────────────────────────────
  {
    path: "./reports/county-weekly-report",
    title: "Reports",
    moduleName: "reports",
    iconType: "feather",
    icon: "bar-chart-2",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["ADMIN"],
    submenu: [],
  },
];
